<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <div class="vb-dialog vb-dialog-danger">
      <v-card data-cy="dialog-deleteComment-modal">
        <v-card-title class="d-flex justify-space-between">
        <span>
          {{ $t('routes.pod.menuComment.deleteComment') }}
        </span>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-5">
          {{ $t('routes.pod.menuComment.deleteCommentDialogMessage') }}
          <blockquote class="pa-2 font-italic">
            {{ comment.content }}
          </blockquote>
          <div v-if="errorMessage" class="bg-error px-1"
               data-cy="dialog-createSubtitle-errorMessage">
            {{ errorMessage }}
          </div>

          <div v-if="errorTranslatable" class="bg-error px-1">
            {{ $replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content) }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-on:click="deleteComment" class="btnOk" elevation=0
                 data-cy="dialog-deleteComment-ok">
            {{ $t('common.delete') }}
          </v-btn>
          <v-btn variant="text" @click="dialog = false" class="btnCancel"
                 data-cy="dialog-deleteComment-false">
            {{ $t('common.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { usePodCommentStore } from '@/stores/PodCommentStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  mixins: [DialogActionKeys],
  name: "CommentDeleteDialog",
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    comment: {
      type: Object,
      required: true,
    }
  },
  data: function() {
    return {
      errorMessage: '',
      errorTranslatable: null,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    deleteComment: function() {
      this.errorMessage = "";
      this.errorTranslatable = null;

      let self = this;

      const podCommentStore = usePodCommentStore();
      podCommentStore.deleteComment(this.comment)
      .then(function() {
        podCommentStore.refreshComments(self.comment.podid);
        self.dialog = false;
      }).catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          const apiError = error.response.data.error.message;
          if (typeof apiError == 'object') {
            self.errorTranslatable = apiError;
          } else {
            self.errorMessage = apiError;
          }
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      });
    }
  }
}
</script>

<style>

</style>
